import { render, staticRenderFns } from "./ChooseCorrectPasteModal.vue?vue&type=template&id=17233104&scoped=true&"
import script from "./ChooseCorrectPasteModal.vue?vue&type=script&lang=js&"
export * from "./ChooseCorrectPasteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17233104",
  null
  
)

export default component.exports